module.exports = __webpack_public_path__ + "media/images/result_sets/circles/9r8n3n6n-06fca9b43f1ff30136d5a4084d161191.svg";